(function() {
  let isLoading = false;

  function handleScroll() {
    const trigger = document.getElementById('infinite-scroll-trigger');
    const gridContainer = document.getElementById('product-grid');
    if (!trigger || !gridContainer) return;

    const nextUrl = trigger.getAttribute('data-next-url');
    if (!nextUrl) return;

    const rect = trigger.getBoundingClientRect();
    // Trigger when the element is within 800px of the bottom of the viewport
    if (rect.top <= window.innerHeight + 800 && !isLoading) {
      loadMoreProducts(trigger, nextUrl, gridContainer);
    }
  }

  async function loadMoreProducts(trigger, nextUrl, gridContainer) {
    isLoading = true;
    
    trigger.innerHTML = '<div style="width: 100%; display: flex; justify-content: center; padding: 20px;"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 40px; height: 40px;"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      
      const newProducts = html.getElementById('product-grid');
      const newTrigger = html.getElementById('infinite-scroll-trigger');

      if (newProducts) {
        Array.from(newProducts.children).forEach(child => {
          // Remove dawn animation classes so they show up immediately
          child.classList.remove('scroll-trigger', 'animate--slide-in');
          child.removeAttribute('data-cascade');
          child.style.opacity = '1';
          child.style.transform = 'none';
          gridContainer.appendChild(child);
        });
      }

      if (newTrigger && newTrigger.getAttribute('data-next-url')) {
        trigger.setAttribute('data-next-url', newTrigger.getAttribute('data-next-url'));
      } else {
        trigger.removeAttribute('data-next-url');
      }
    } catch (error) {
      console.error('Infinite Scroll Error:', error);
    } finally {
      isLoading = false;
      trigger.innerHTML = '';
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', handleScroll);
  // Re-check periodically in case facets.js modifies the DOM
  setInterval(handleScroll, 1000);
})();
